import { Plugins, FilesystemDirectory } from '@capacitor/core';
import { Market } from '@ionic-native/market';
import { AppVersion } from '@ionic-native/app-version';
import { FileOpener } from '@ionic-native/file-opener';
import download from 'downloadjs';

// Constants
import { APP_CONFIG } from '../constants';

// Helpers
import { isAndroid, isIOS, isNative, loadVersion, getFileName } from './../helpers';
import { getMimeType } from './file.helper';

const { Filesystem } = Plugins;

/**
 * Abre el Store correspondiente
 */
export const redirectStore = () => {

    if ( isAndroid() ) {

        Market.open(APP_CONFIG.APP.ANDROID.APPID);
    }

    if ( isIOS() ) {

        Market.open(APP_CONFIG.APP.IOS.APPID);
    }

    return null;
};

/**
 * Devuelve el color que corresponde en caso de tratarse de un Error o no
 * @param {Number} statusCode Estado del tipo de respuesta de la api de Credencial Virtual
 */
export const resolveColorMessageByStatusCode = ( statusCode ) => {

    if ( statusCode == null ) { return 'primary'; }

    return APP_CONFIG.API.VIRTUAL_CREDENTIAL.ERROR_CODE_TOAST.filter( code => code === statusCode).length > 0 ?
     'danger' : 'primary' ;
}

/**
 * Determina si la app debe cerrarse de acuerdo al pathname dentro de la zona privada
 * @param {String} currentPathName pathname actual
 */
export const closeAppInPagePrivate = (currentPathName = '') => {

    // Si es nativo
    if ( isNative() ) {

        if (currentPathName === '/' || currentPathName === APP_CONFIG.PAGES.QR_SCAN.path || currentPathName === APP_CONFIG.PAGES.DOCUMENT.path) {
    
            return true;
        }
    }

    return false;
};

/**
 * Determina si la app debe cerrarse de acuerdo al pathname dentro de la zona pública
 * @param {String} currentPathName pathname actual
 */
export const closeAppInPagePublic = (currentPathName = '') => {

    if ( isNative() && 
    (currentPathName === '/' || currentPathName === APP_CONFIG.PAGES.LOGIN.path)) {

        return true;
    }

    return false;
};

/**
 * Obtiene la versión de la app de acuerdo al dispositivo (Web, Android, IOS)
 */
export const getVersion = async () => {

    if ( isNative() ) {

        return await AppVersion.getVersionNumber();
    }

    return Promise.resolve(loadVersion());
}

/**
 * Convierte un Blob a base64
 * @param {Object} blob Archivo en formato blob
 */
export const convertBlobToBase64 = async (blob) => new Promise((resolve, reject) => {

    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {

        resolve(reader.result);
    };

    reader.readAsDataURL(blob);
});

/**
 * Descarga el recurso de la url adaptándose al dispositivo
 * @param {String} url Url del recurso a descarcar
 */
export const downloadFile = async ( url ) => {

    const fileName = getFileName(url);
    const mimeType = getMimeType(fileName);
    if (isNative()) {

        const resp = await fetch(url);
        const body = await resp.blob();
        const base64 = await convertBlobToBase64(body);

        const savedFile = await Filesystem.writeFile({

            path: fileName,
            data: base64,
            directory: FilesystemDirectory.Documents
        });

        const path = savedFile.uri;
        await FileOpener.open(path, mimeType);
    }
    else {

        const resp = await fetch(url);
        const data = await resp.blob();

        download(data, fileName, mimeType);
    }
}